import { defineStore } from 'pinia';
import { ref } from 'vue';

const useAppStore = defineStore('app', () => {
  const hideMenu = ref(false);
  const menuCollapse = ref(false);
  const device = ref('desktop');

  const toggleDevice = (newDevice: string) => {
    device.value = newDevice;
  };

  const toggleMenu = (value: boolean) => {
    hideMenu.value = value;
  };

  return {
    hideMenu,
    menuCollapse,
    device,
    toggleDevice,
    toggleMenu,
  };
});

export default useAppStore;
